export default {"src":"/_next/static/media/password.60ccf91f.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};